// Utilitários de validação

export const validateWalletAddress = (address) => {
  // Validação básica de endereço de carteira
  return /^(0x)?[a-fA-F0-9]{40}$|^[A-Z0-9]{34,35}$/.test(address);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^\+?[\d\s\-()]{10,}$/;
  return phoneRegex.test(phone);
};

/** Extrai apenas dígitos do telefone */
export const getPhoneDigits = (phone) => (phone || '').replace(/\D/g, '');

/**
 * Formata telefone BR para exibição: (11) 9 8765-4321 ou (11) 8765-4321
 * @param {string} value - texto atual (pode conter dígitos e formatação)
 * @returns {string} - formatado com máscara
 */
export const formatPhoneBR = (value) => {
  const digits = getPhoneDigits(value).slice(0, 11);
  if (digits.length <= 2) return digits.length ? `(${digits}` : '';
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 3)} ${digits.slice(3, 7)}-${digits.slice(7)}`;
};

export const validateAmount = (amount) => {
  const num = parseFloat(amount);
  return !isNaN(num) && num > 0;
};

export const validateJSON = (jsonString) => {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
};

export const validateWalletImportData = (data) => {
  try {
    const parsed = JSON.parse(data);
    return Array.isArray(parsed) && parsed.every(w =>
      w.name && w.address && validateWalletAddress(w.address)
    );
  } catch (error) {
    return false;
  }
};
